import { Grid, makeStyles } from '@material-ui/core'
import Tooltip from 'components/common/Tooltip'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import React from 'react'
import NumberWidgetSkeleton from './NumberWidgetSkeleton'
import InfoOutlined from 'components/common/icons/InfoOutlined'

const useStyles = makeStyles(theme => ({
  root: {
    height: 100,
    borderRadius: 24,
    background: '#FFFFFF',
    padding: 20,
    paddingBottom: 0
  },
  valueLabel: props => ({
    marginTop: 5,

    [theme.breakpoints.up('sm')]: {
      marginTop: 0
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 0
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 10
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: 10
    }
  }),
  icon: {
    marginRight: 5
  },
  textWithTooltip: {
    display: 'flex',
    alignItems: 'center'
  },
  tooltip: {
    marginLeft: 5
  }
}))

const NumberWidget = ({ label, value, icon, isLoading = true, tooltipText = '' }) => {
  const classes = useStyles()

  const formatNumberWithCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return isLoading ? (
    <NumberWidgetSkeleton />
  ) : (
    <Grid container className={classes.root} wrap="nowrap">
      <Grid className={classes.icon}>{React.createElement(icon)}</Grid>
      <Grid container direction="column">
        <Grid>
          <DazzedHeadingForGrid regular xs={14} sm={14} md={14} lg={16} xl={16} className={classes.textWithTooltip}>
            {label}
            {tooltipText && (
              <Tooltip value={tooltipText} containerClassName={classes.tooltip} placement="top" arrow variant="light">
                <InfoOutlined color="#727B8C" />
              </Tooltip>
            )}
          </DazzedHeadingForGrid>
        </Grid>
        <Grid>
          <DazzedHeadingForGrid className={classes.valueLabel} bold xs={30} sm={30} md={30} lg={40} xl={40}>
            {!value || value === 0 ? '-' : formatNumberWithCommas(value)}
          </DazzedHeadingForGrid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NumberWidget
